import { render, staticRenderFns } from "./CreatorCommentsDrawer.vue?vue&type=template&id=e15583ca&scoped=true&"
import script from "./CreatorCommentsDrawer.vue?vue&type=script&lang=js&"
export * from "./CreatorCommentsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CreatorCommentsDrawer.vue?vue&type=style&index=0&id=e15583ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15583ca",
  null
  
)

export default component.exports